const PageNotFound = () => {
  return (
    <div>
      <h3>This page does not exist.</h3>
    </div>
  )
}

export default PageNotFound;